import controller from './vd-carousel-frame.controller'

export default {
  controller,
  template: '<div class="vd-carousel-frame-content" ng-transclude></div>',
  require: {
    vdCarousel: '^^vdCarousel',
  },
  transclude: true,
}
